import { GetDocumentTypeDto } from 'src/app/modules/doc-types/models/doc-types.model';
import { LanguageDto } from 'src/app/shared/services/languages-api.service';
import { PositionDto } from 'src/app/shared/services/positions-api.service';
import { PlaybookDto } from './models/playbooks.model';

export interface PlaybookNameContext {
  docTypeItems: GetDocumentTypeDto[];
  positionItems: PositionDto[];
  contentLanguages: LanguageDto[];
  selectPlaceholder: string;
  nonePlaceholder: string;
}

type PlaybookNameSource = Pick<
  PlaybookDto,
  'name' | 'documentTypeId' | 'positionId' | 'languageId'
>;

export function getPlaybookDisplayLabel(
  playbook: PlaybookNameSource,
  context: PlaybookNameContext,
): string {
  return buildPlaybookPreviewName(playbook, context);
}

export function buildPlaybookPreviewName(
  playbook: Pick<PlaybookDto, 'name' | 'documentTypeId' | 'positionId' | 'languageId'>,
  context: PlaybookNameContext,
): string {
  const documentTypeName =
    context.docTypeItems.find((docType) => docType.id === playbook.documentTypeId)?.name ||
    context.selectPlaceholder;
  const positionName =
    context.positionItems.find((position) => position.id === playbook.positionId)?.name ||
    context.selectPlaceholder;
  const languageName =
    context.contentLanguages.find((language) => language.id === playbook.languageId)?.displayName ||
    context.selectPlaceholder;
  const playbookName = playbook.name?.trim() || context.nonePlaceholder;

  return `${documentTypeName} - ${positionName} - ${languageName} - ${playbookName}`;
}